import { Component, OnInit } from '@angular/core';
import { AppService } from '../Shared/services/app.service';
import { GetSetService } from '../Shared/services/getset.serverce';
import { HttpStatusCode, ResponseModel } from 'src/app/Shared/model/response.model';
import { ApiDataService } from 'src/app/Shared/services/apidata.service';
import { IUserProfileInfo } from '../Shared/model/model/userprofileinfo.model';
import { Messagetype } from '../Shared/model/enum';
import { ToastService } from '../Shared/services/toast.service';
import { IOrder } from '../Shared/model/order.model';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  userInfo?: IUserProfileInfo;
  orderList: IOrder[] = [];
  user:any;

  constructor(
    private appService: AppService,
    private getSetService: GetSetService,
    private apiDataService: ApiDataService,
    private toast: ToastService,
  ) { }

  ngOnInit(): void {
    this.user = this.getSetService.getCurrentUserInfo();
    this.getProfile();
    this.getOrderlist();
  }

   // User Profile Details
   getProfile() {
    const user = this.getSetService.getCurrentUserInfo();
    const url = `User/UserProfileInfo`;
    this.apiDataService.getData(url).subscribe
        ((response: ResponseModel<any>) => {
          if (response.status === HttpStatusCode.OK) {
            this.userInfo = response.data;
          }
        })
  }

  getOrderlist(){
    const user = this.getSetService.getCurrentUserInfo();
    const url = `Order/GetOrderAsync`;
this.apiDataService
  .getData(url)
  .subscribe((response: ResponseModel<any>) => {
    if (response.status === HttpStatusCode.OK) {
      this.orderList = response.data ;
    }
  });

}

}
